export const logout = (setActive, navigate) => {
    if (localStorage.getItem('user')) {
        localStorage.removeItem('user');
    }
    if (localStorage.getItem('dictionaryCountries')) {
        localStorage.removeItem('dictionaryCountries');
    }
    if (localStorage.getItem('dictionaryVessels')) {
        localStorage.removeItem('dictionaryVessels');
    }
    if (localStorage.getItem('dictionaryOrg')) {
        localStorage.removeItem('dictionaryOrg');
    }
    if (localStorage.getItem('dictionaryCities')) {
        localStorage.removeItem('dictionaryCities');
    }
    if (localStorage.getItem('dictionaryPorts')) {
        localStorage.removeItem('dictionaryPorts');
    }
    if (localStorage.getItem('dictionaryCaptains')) {
        localStorage.removeItem('dictionaryCaptains');
    }
    if (localStorage.getItem('dictionaryConsignee')) {
        localStorage.removeItem('dictionaryConsignee');
    }
    if (localStorage.getItem('logged')) {
        localStorage.removeItem('logged');
    }
    setActive(false);
    navigate('/auth', {replace: true });
}